// removed by extract-text-webpack-plugin
module.exports = {"root":"address-form--root--35_kLnMP organization-home--root--29mpR9MJ","button-container":"address-form--button-container--2W26KjGC","buttonContainer":"address-form--button-container--2W26KjGC","buttons-container":"address-form--buttons-container--2PbTfLdY","buttonsContainer":"address-form--buttons-container--2PbTfLdY"};


//////////////////
// WEBPACK FOOTER
// ./views/addresses/address-form/styles.css
// module id = ./views/addresses/address-form/styles.css
// module chunks = 0